import { QueryStringController } from "./QueryStringController";
import { RevenuePrices } from "./RevenuePrices";
import { Templates } from "./Templates";
import { Utility } from "./Utility";

/**Form for filtering down list of price definitions.  Handles changes in state. */
export class RevenuePriceStateForm
{
	private _stateSelection: StateFormView;
	private _data: any;
	private _parent: RevenuePrices;
	private _queryStringController: QueryStringController;
	private _stateCodes: Array<string>;

	/**
	 * Constructor for state selection form
	 * @param parent parent object that runs the application
	 * @param queryController object for getting and setting query string values
	 */
	constructor(parent: RevenuePrices, queryController: QueryStringController)
	{
		this._parent = parent;
		this._queryStringController = queryController;
		this._stateCodes = [];
		this._stateSelection = {
			Filter: "All",
			State: "",
			Year: ""
		};
	}

	/**
	 * Build out new Form for filtering price definitions
	 * @param data data from service
	 * @param defaults default selections
	 */
	public BuildForm(data, defaults: StateFormView)
	{
		this._data = data;
		this._stateSelection = defaults;

		this.SyncMap(defaults.State);

		$('#' + Templates.Ids.revenueStateFormSelection).dxForm({
			showRequiredMark: false,
			formData: this._stateSelection,
			items: [
				{
					dataField: "State",
					editorType: 'dxSelectBox',
					label: {
						text: "State"
					},
					editorOptions: {
						items: this.FormattedStateCollection(),
						searchEnabled: false,
						onValueChanged: (e) =>
						{
							this.SyncMap(e.value);

							this._queryStringController.Update(null, this._parent._priceDefinitionForm.GetCurrentSelections());
							Utility.ReloadPricesGrid();
						}
					}
				},
				{
					dataField: "Year",
					editorType: 'dxSelectBox',
					label: {
						text: "Year"
					},
					editorOptions: {
						items: this._data['filterReinsuranceYears'],
						searchEnabled: false,
						onValueChanged: () =>
						{
							this._queryStringController.Update(null, this._parent._priceDefinitionForm.GetCurrentSelections());
							Utility.ReloadPricesGrid();
						}
					}
				},
				{
					dataField: "Filter",
					editorType: 'dxSelectBox',
					label: {
						text: "Filter"
					},
					editorOptions: {
						items: ["All"], // Simple list to start, until full list loads.  Makes UI show "All" instead of a empty drop down when loading data
						searchEnabled: false,
						onValueChanged: (e) =>
						{
							this.SetFilterValueEvent(e.value);
						}
					}
				}
			]
		});
	}

	SetNewFiltersDataSource(items: string[])
	{
		items.unshift("All");

		// We can keep the same filter if it exists in the new filter list loaded.
		if (items.indexOf(this._stateSelection.Filter) === -1)
		{
			this._stateSelection.Filter = "All";
			this.SetNewValues(this._stateSelection);
		}

		$('#' + Templates.Ids.revenueStateFormSelection).dxForm("instance").getEditor("Filter")!.option("items", items);
	}

	SetNewValues(values: StateFormView)
	{
		if (this._stateSelection !== undefined)
		{
			this._stateSelection.State = values.State;
			this._stateSelection.Year = values.Year;
			this._stateSelection.Filter = values.Filter;
		}
		else
		{
			this._stateSelection = values;
		}

		$('#' + Templates.Ids.revenueStateFormSelection).dxForm("instance").option("formData", this._stateSelection);
	}

	GetCurrentSelections()
	{
		return this._stateSelection;
	}

	GetStateCode(stateAbbr: string | undefined)
	{
		if (stateAbbr !== undefined)
		{
			return this._stateCodes[stateAbbr];
		}
		return "";
	}

	GetDisplayMessageFromSelections()
	{
		if (this._stateSelection !== undefined)
		{
			return this._stateSelection.State + " " + this._stateSelection.Year;
		}
		else
		{
			return "";
		}
	}

	private SyncMap(selectedStateValue)
	{
		var mapItems = $('#' + Templates.Ids.vectorMapContainer).dxVectorMap('instance').getLayers()[0].getElements();
		mapItems.forEach((element) => {
			if (element.attribute('name') === selectedStateValue)
			{
				element.selected(true);
			}
		});
	}

	private SetFilterValueEvent(newValue: string)
	{
		if (newValue !== 'All')
		{
			this._stateSelection.Filter = newValue;
		}

		if (newValue === "All")
		{
			$('#' + Templates.Ids.gridContainer).dxDataGrid("instance").clearFilter();
		}
		else
		{
			$('#' + Templates.Ids.gridContainer).dxDataGrid("instance").filter(["commodity", "=", newValue]);
		}

		this._parent.UpdatePageStateWithCurrentSelections();
	}

	private FormattedStateCollection()
	{
		let formattedData: string[] = [];
		$.each(this._data['filterStates'], (key, val) =>
		{
			if (this._parent._blacklistedStates.indexOf(val['name']) === -1)
			{
				formattedData.push(val['name']);
				this._stateCodes[val['name']] = val['code'];
			}
		});

		return formattedData;
	}
}

/**Selections tied to the form for filtering price definitions */
export interface StateFormView
{
	/**State selection */
	State: string;
	/**Reinsurance year selection */
	Year: string;
	/**Crop filter */
	Filter: string;
}